import { useState, useEffect } from 'react';

const STORAGE_KEY = 'rad_favourites';

export function useFavourites() {
  const [favourites, setFavourites] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(favourites));
  }, [favourites]);

  const isFavourite = (productId) => favourites.includes(productId);

  const toggleFavourite = (productId) => {
    setFavourites(prev =>
      prev.includes(productId)
        ? prev.filter(id => id !== productId)
        : [...prev, productId]
    );
  };

  return { favourites, isFavourite, toggleFavourite };
}
